import './vendors/bootstrap/bootstrap-datatable'
import './vendors/asap/ASAP'
import './vendors/bootstrap/bootstrap-slider'
import './vendors/bootstrap/bootstrap3-typeahead'
import './vendors/bootstrap/validator'
import './vendors/jquery/jquery.tablesorter'

import './vendors/bootstrap-select/bootstrap-select'

/* Todo: remove nvd3 from here, too huge non minified */
import * as Tagify from './vendors/tagify/tagify.min.js'

import './vendors/datatables/datatable-ipsorting'
import './vendors/datatables/datatable-macsorting'
import './vendors/datatables/datatable-colvisibility'

window.Tagify = Tagify
